import client from './client';
export const tenantAPI = {
    async getProfile() {
        const response = await client.get('/tenants/profile');
        return response.data.data;
    },
    async updateProfile(data) {
        const response = await client.put('/tenants/profile', data);
        return response.data.data;
    },
};
